import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SCConfig } from '../../sc-config/constant/sc-config.constant';
import { Observable } from 'rxjs';
import { QueryHandlerResponse } from '../models/responseModels/QueryHandlerResponse';
import { ApplicationNotification } from '../../root/models/application-notification.model';
import { IpexCommandResponse } from '../models/responseModels/IpexCommandResponse';
import { NotificationCommand } from '../models/commandModels/NotificationCommand';
import { UrlResolverService } from './url/url-resolver.service';

@Injectable({
    providedIn: 'root'
})
export class AppNotificationService {
    private readonly urlResolver = inject(UrlResolverService);
    private readonly pcxCommandUrl: string = this.urlResolver.getPcxCommandUrl();
    private readonly pcxQueryUrl: string = this.urlResolver.getPcxQueryUrl();
    private readonly getApplicationNotification: string = `${this.pcxQueryUrl}GetApplicationNotification` as const;
    private readonly markStatusUrl: string = `${this.pcxCommandUrl}MarkAsRead` as const;
    private readonly clearAllNotificationUrl: string = `${this.pcxCommandUrl}ClearNotifications` as const;


    constructor(private httpClient: HttpClient) {}

    public getApplicationNotifications(): Observable<QueryHandlerResponse<null, ApplicationNotification[]>> {
        const payload = {
            NumberOfNotificationHistoryDays: 5
        };
        return this.httpClient.post<QueryHandlerResponse<null, ApplicationNotification[]>>(
            this.getApplicationNotification,
            payload,
            {
                headers: SCConfig.HttpCommonHeader,
                withCredentials: true
            }
        );
    }

    public updateNotificationMarkStatus(command: NotificationCommand): Observable<IpexCommandResponse<boolean>> {
        return this.httpClient.post<IpexCommandResponse<boolean>>(this.markStatusUrl, command, {
            headers: SCConfig.HttpCommonHeader,
            withCredentials: true
        });
    }

    public clearAllNotification(command: NotificationCommand): Observable<IpexCommandResponse<boolean>> {
        return this.httpClient.post<IpexCommandResponse<boolean>>(this.clearAllNotificationUrl, command, {
            headers: SCConfig.HttpCommonHeader,
            withCredentials: true
        });
    }

}
